import { defineComponent as _defineComponent } from 'vue'
import { useSnackbarStore } from "@/pinia/snackbar";
import ApplicationFooter from "@/components/ApplicationFooter.vue";
import ApplicationHeader from "@/components/ApplicationHeader.vue";
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import {
  ApiService,
  LogService,
  RouterService,
  SearchService,
  SnackbarService,
} from "@/services";
import { useBriefcaseStore } from "@/pinia/briefcase";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const briefcaseStore = useBriefcaseStore();

const snackbarStore = useSnackbarStore();
const { snackbar } = snackbarStore;

SearchService._initialize();
LogService._initialize();
SnackbarService._initialize();
ApiService._initialize();
RouterService._initialize();
LogService.debug("Almanac+ services initialized.");

const openMoveDialog = () => {
  // Retrieve the search item from the snackbar store, and set it as the
  // briefcase item. This will trigger the modal to appear.
  briefcaseStore.meta.itemBeingMoved = snackbar.itemBeingMoved;

  // Close out and reset snackbar.
  SnackbarService.closeSnackbar();
};

return { __sfc: true,briefcaseStore, snackbarStore, snackbar, openMoveDialog, ApplicationFooter, ApplicationHeader, NjBtn }
}

})